import { useSecurityMeasuresQuery } from "@common/hooks/useSelectableItemQueries.ts";
import { getSecurityMeasureSuggestions } from "../../../../incidentLog/incidentLogDialog/CreateEditIncidentLogDialog.hooks.ts";

export function useIncidentLogMeasuresField(isPreview: boolean) {
    const securityMeasuresQuery = useSecurityMeasuresQuery(!isPreview, false);
    return { securityMeasureSuggestions: getSecurityMeasureSuggestions(securityMeasuresQuery.data) };
}
